import React, { useState, useEffect } from 'react';
import { Typography, CircularProgress } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Link } from 'react-router-dom';

import api from '../../../services/api';
import {
  Container,
  FormContainer,
} from './ValidateEmailStyles';

export default function ValidateEmail(props: any) {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = props.match.params.token;
    if (!token) {
      setStatus('error');
      setMessage('Link inválido.');
      return;
    }

    api.get(`/validateEmail/${token}`)
      .then(res => {
        setStatus('success');
        setMessage(res.data.message);
      })
      .catch(err => {
        setStatus('error');
        setMessage(
          (err.response && err.response.data && err.response.data.error) ||
          'Erro ao verificar o email.'
        );
      });
  }, [props.match.params.token]);

  return (
    <Container>
      <FormContainer>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '16px',
          padding: '40px',
        }}>
          {status === 'loading' && (
            <>
              <CircularProgress size={48} />
              <Typography variant="h5" color="primary">
                Verificando seu email...
              </Typography>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircleOutlineIcon style={{ fontSize: '64px', color: '#4BDC4B' }} />
              <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
                {message}
              </Typography>
              <Typography variant="body2" style={{ color: '#ffffffcc' }}>
                Sua conta está ativa. Faça login para continuar.
              </Typography>
              <Link
                to="/login"
                style={{
                  marginTop: '16px',
                  padding: '10px 32px',
                  background: '#ffee58',
                  borderRadius: '4px',
                  color: '#1E2141',
                  textDecoration: 'none',
                  fontWeight: 700,
                }}
              >
                Ir para o login
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <ErrorOutlineIcon style={{ fontSize: '64px', color: '#FF6347' }} />
              <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
                Falha na verificação
              </Typography>
              <Typography variant="body2" style={{ color: '#ffffffcc' }}>
                {message}
              </Typography>
              <Link
                to="/login"
                style={{
                  marginTop: '16px',
                  padding: '10px 32px',
                  background: '#2C325C',
                  borderRadius: '4px',
                  color: '#fff',
                  textDecoration: 'none',
                }}
              >
                Ir para o login
              </Link>
            </>
          )}
        </div>
      </FormContainer>
    </Container>
  );
}
